import React, { Component } from "react";
import Layout from "./components/Layout";
import "./App.css";
import TutorialIntro from "./components/Tutorial/tutorial.container";

import { enableMapSet } from "immer";

import "primereact/resources/themes/fluent-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { createTheme, loadTheme } from "office-ui-fabric-react";

const myTheme = createTheme({
    palette: {
        defaultFontStyle: { fontFamily: "'Inter'", fontWeight: "normal" },
        //themePrimary: "#0C92CD",
        themePrimary: "#0C92CD",
        themeLighterAlt: "#060900",
        themeLighter: "#053b51",
        themeLight: "#044c6a",
        themeTertiary: "#096e9d",
        themeSecondary: "#0875a5",
        themeDarkAlt: "#0a84b7",
        themeDark: "#0cb3fd",
        themeDarker: "#7cdbf6",
        neutralLighterAlt: "#f8f8f8",
        // neutralLighter: '#f4f4f4',
        neutralLighter: "#000000", // default button non-hover color, disabled input color, etc.
        neutralLight: "#eaeaea",
        neutralQuaternaryAlt: "#dadada",
        neutralQuaternary: "#d0d0d0",
        neutralTertiaryAlt: "#c8c8c8", // excluded side of sliders (not selected values)
        // neutralTertiary: '#595959',
        neutralTertiary: "#d3dfe5", // borders of text boxes, disabled input text, etc.
        neutralSecondary: "#373737",
        neutralPrimaryAlt: "#2f2f2f",
        neutralPrimary: "#000000",
        // neutralPrimary: '#ffffff',
        neutralDark: "#151515",
        black: "#0b0b0b",
        white: "#ffffff",
    },
});

/* Specifically change the font */
myTheme.fonts = {
    "tiny": {
        "fontFamily": "aeondikBold",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "10px",
        "fontWeight": 400,
    },
    "xSmall": {
        "fontFamily": "aeondikBold",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "11px",
        "fontWeight": 400,
    },
    "small": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "12px",
        "fontWeight": 400,
    },
    "smallPlus": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "13px",
        "fontWeight": 400,
    },
    "medium": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "14px",
        "fontWeight": 400,
    },
    "mediumPlus": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "15px",
        "fontWeight": 400,
    },
    "large": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "17px",
        "fontWeight": 300,
    },
    "xLarge": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "21px",
        "fontWeight": 100,
    },
    "xLargePlus": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "21px",
        "fontWeight": 100,
    },
    "xxLarge": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "28px",
        "fontWeight": 100,
    },
    "xxLargePlus": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "28px",
        "fontWeight": 100,
    },
    "superLarge": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "42px",
        "fontWeight": 100,
    },
    "mega": {
        "fontFamily": "'Inter'",
        "MozOsxFontSmoothing": "grayscale",
        "WebkitFontSmoothing": "antialiased",
        "fontSize": "72px",
        "fontWeight": 100,
    },
};

loadTheme(myTheme);

enableMapSet();

class App extends Component{
    render() {
        return (
            <div className="App">
                <TutorialIntro>
                    <Layout/>
                </TutorialIntro>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js